import { Button, Form, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { emptyVideo, Video } from "../../interfaces/Video";
import Uploader from "../../elements/Uploader";
import { Media } from "../../interfaces/Media";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";
import { handleApiError, safeJsonParse } from "../../../utils/api";

export interface VideoAddProps {
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function VideoAdd(props: VideoAddProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    const [media, setMedia] = useState<Media[]>([]);
    
    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        let error = false;
        let error_messages: string[] = [];
        
        if (error) {
            alert(error_messages.join('\n'));
        } else {
            const newVideo: Video = Object.assign({}, emptyVideo);
            newVideo.title = event.target.title.value;
            newVideo.description = event.target.description.value;
            newVideo.media = media.map((m: Media) => { return m; });
            const requestOptionsPost = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newVideo)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/video-tutorials', requestOptionsPost)
                .then(response => {
                    if (handleApiError(response, navigate)) {
                        return null;
                    }
                    return safeJsonParse(response);
                })
                .then(data => {
                    if (!data) return;
                    props.submitCallback(data);
                });
        }
    }

    const handleMediaUpload = (media: Media[]) => {
        const newMedia: Media[] = [];
        if (media.length > 0) {
            newMedia.push(media.slice(-1)[0])
            const hasVideos = newMedia.filter((m: Media) => m.mimetype == 'video/mp4').length > 0;
            if (!hasVideos) {
                alert(t("Only MP4 videos are allowed."));
                return;
            }
            setMedia(newMedia);
        }
    }

    return(
        <Overlay title={t("Add new Video")} onClose={handleClose} className="admin-add-video-container">
            <div className="video-form-container">
                <Form onSubmit={ handleSubmit }>
                    <FormGroup className="title" controlId="title">
                        <Form.Label aria-required={ true }>{ t("Title") }</Form.Label>
                        <Form.Control type="text" required={ true } name="title"
                            placeholder={ t("Enter a title") } />
                    </FormGroup>
                    <Form.Group className="field field-description">
                        <FormLabel htmlFor="description">{ t("Description") }</FormLabel>
                        <FormControl as="textarea" name="description" />
                    </Form.Group>
                    <Uploader media={ media } save={ handleMediaUpload } />
                    <div className="actions">
                        <Button type="submit" variant="primary">{ t("Save") }</Button>
                    </div>
                </Form>
            </div>
        </Overlay>
    );
}